/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { colors, timings } from "../../theme";

const Tab = ({ text, selected }) => (
    <div
        css={css`
            cursor: pointer;
            border-bottom: ${
                selected
                    ? `3px solid ${colors.accent5};`
                    : `3px solid ${colors.neutral2};`
            }
            &:hover {
                border-bottom: ${
                    selected
                        ? `3px solid ${colors.accent5};`
                        : `3px solid ${colors.accent2};`
                }
            }
            ${selected && "font-weight: 800;"};
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            transition: border-bottom ${timings.medium};
            & p {
                margin-bottom: 14px;
                max-width: 80%;
                color: ${
                    selected ? `${colors.neutral8};` : `${colors.neutral6};`
                };
            }
        `}
    >
        <p>{text}</p>
    </div>
);

const TabSelect = ({ tabTitles, selectTab, selectedTabTitle }) => (
    <div
        css={css`
            width: 100%;
            display: flex;
            flex-direction: column;
        `}
    >
        <div
            data-testid="tab-container"
            css={css`
                display: flex;
                flex-direction: row;
            `}
        >
            {tabTitles.map(tabTitle => (
                <button
                    type="button"
                    key={tabTitle}
                    css={css`
                        width: 100%;
                        padding: 0;
                        background: none;
                        color: inherit;
                        border: none;
                        padding: 0;
                        font: inherit;
                        cursor: pointer;
                        outline: inherit;
                    `}
                    onClick={() => selectTab(tabTitle)}
                    className={
                        tabTitle === selectedTabTitle
                            ? "selected-tab"
                            : "unselected-tab"
                    }
                >
                    <Tab
                        text={tabTitle}
                        selected={tabTitle === selectedTabTitle}
                    />
                </button>
            ))}
        </div>
    </div>
);

export default TabSelect;
